<template>
    <el-scrollbar class='scrollbar' :max-height="dialog_scrollbar_max_height" ref="dialog_scrollbar_ref">
        <div class='sentences' ref="sentences_ref">
            <sentence v-for="sentence in sentences" :key="sentence.id" :sentence="sentence.content" :role="sentence.role"/>
        </div>
    </el-scrollbar>
</template>


<script>
import { ref, inject } from 'vue'
import { mapMutations } from "vuex"
import { ElScrollbar } from 'element-plus'
import sentence from './sentence.vue'


export default {
    components: {
        ElScrollbar,
        sentence
    },

    setup(props, {expose}) {
        let window_width=window.screen.width
        let dialog_scrollbar_max_height=ref('')
        let dialog_scrollbar_ref=ref(null)
        let sentences_ref=ref(null)
        let sentences = inject('sentences');
        let scroll_height = ref(0)

        /*
        const dialog_scrollbar_ref = (el) => {
            dialog_scrollbar_ref_array.value[0]=el
        }
        */

        let set_dialog_scrollbar_max_height = (emoticon_show) => {
            //console.log("set_dialog_scrollbar_max_height")
            if (window_width >= 1080) {
                dialog_scrollbar_max_height.value=(emoticon_show?'1.4rem':'4.4rem')
                //console.log("dialog_scrollbar_max_height=", dialog_scrollbar_max_height)
            }
            else if (window_width >= 768) {
                dialog_scrollbar_max_height.value=(emoticon_show?'52vh':'93vh')
            }
            else {
                dialog_scrollbar_max_height.value=(emoticon_show?'40vh':'91vh')
            }
        }

        expose({set_dialog_scrollbar_max_height})

        return {
             dialog_scrollbar_ref
            ,dialog_scrollbar_max_height
            ,sentences
            ,sentences_ref
            ,window_width
            ,set_dialog_scrollbar_max_height
            ,scroll_height
        }
    },

    methods: {
        ...mapMutations(["set_set_emoticon_flag"]),
        ...mapMutations(["set_dialoge_initialisation"]),
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
    },

    mounted() {
        this.set_dialog_scrollbar_max_height(false)
        const self = this;
        this.$emitter.on('add_to_history', async () => {
            //console.log("add_to_history received!")
            //console.log("this.scroll_height=", JSON.stringify(self.scroll_height))

            while (self.dialog_scrollbar_ref == null) {
                await self.sleep(100)
            }

            while (self.scroll_height == self.dialog_scrollbar_ref.wrapRef.scrollHeight) {
                await self.sleep(100)
            }

            //console.log("this.dialog_scrollbar_ref.wrapRef.scrollHeight=", JSON.stringify(this.dialog_scrollbar_ref.wrapRef.scrollHeight))
            self.scroll_height= self.dialog_scrollbar_ref.wrapRef.scrollHeight
            self.dialog_scrollbar_ref.scrollTo({ top: self.dialog_scrollbar_ref.wrapRef.scrollHeight, left: 0, smooth: true })
        })
    },

    updated () {
        //console.log("this.$store.state.set_emoticon_flag=",JSON.stringify(this.$store.state.set_emoticon_flag))
        if (this.$store.state.set_emoticon_flag) {
            this.set_set_emoticon_flag(false)
            this.dialog_scrollbar_ref.scrollTo({ top: this.dialog_scrollbar_ref.wrapRef.scrollHeight, left: 0, smooth: true })
        }
    }
}

</script>

<style scoped>

    .sentences {
        max-height: v-bind("dialog_scrollbar_max_height");
    }

    @media screen and (max-width: 768px){
        .pc {
            display: none
        }

        .sentences {
            font-size: 5vw;
        }

    }

    @media screen and (max-width: 1080px) and (min-width: 768px){
        .pc {
            display: none
        }
    }

    @media screen and (min-width: 1080px){
        .mobile {
            display: none
        }
    }


</style>
